import { default as React, useState, useContext, useEffect } from 'react'
import { useNavigate, useSearchParams  } from 'react-router-dom'
import { Factory } from '@mui/icons-material'
import ListOwnerships from './ListOwnerships'

import ListViewCommandBar from '../commandBar/ListViewCommandBar'
import Page from '../layout/Page'
import { ROLES } from '../auth/role'
import RoleContext from '../auth/RoleContext'
import { Paper } from '@mui/material'
import TabPanel from '../form/TabPanel'
import { useLocalStorage } from '../utils/ReactUtils'

export default function ListOwnershipsPage (props = {}) {
  const roleDetails = useContext(RoleContext)
  const [isLoading, setIsLoading] = useState(true)
  const [selectedTab, setSelectedTab] = useState(0)
  const [searchParams, setSearchParams] = useSearchParams({ view: 'active', page: '1'})
  const navigate = useNavigate()

  const startLoading = () => {
    setIsLoading(true)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }

  const breadcrumb = <span><Factory/>&nbsp;Ownerships</span>

  const [showFilters, setShowFilters] = useLocalStorage("showFilters", false)
  const toggleFilters = () => {
    setShowFilters(!showFilters);
  }

  const addRecord = () => {
    navigate('/ownership/create')
  }

  const tabChange = (event, toTab) => {
    setSearchParams({view: toTab === 1 ? 'inactive' : 'active'})
  }

  useEffect(() => {
    setSelectedTab(searchParams.get('view') === 'inactive' ? 1 : 0)
  }, [searchParams])

  return (
    <Page { ...props} breadcrumb={breadcrumb} isLoading={isLoading} 
      commandBar={
        <ListViewCommandBar 
          showFilters={true}
          filtersEnabled={showFilters}
          toggleFilters={toggleFilters} 
          addRecord={addRecord} 
          showAdd={roleDetails.isQualityManager()}  
        />
      }>
        <Paper sx={{margin: '0 auto 1em auto' }}>
          { (roleDetails.isInternalUser() || roleDetails.hasRole([ROLES.IM_MANAGER])) && 
            <TabPanel panelId='facilities' key='facilities' tabs={[
              {
                key: 'active',
                label: 'Active',
                el: (
                <ListOwnerships showFilters={showFilters} startLoading={startLoading} stopLoading={stopLoading} searchFilter={{isActive: true}} />
                )
              },
              {
                key: 'inactive',
                label: 'Inactive',
                el: (
                  <ListOwnerships showFilters={showFilters} startLoading={startLoading} stopLoading={stopLoading} searchFilter={{isActive: false}} />
                )
              }
            ]} tabStyle={{ textTransform: 'none', minHeight: 'unset'}}
              defaultTab={selectedTab}
              onTabChange={(idx) => tabChange(null, idx)}
            />
          }
          { roleDetails.isBottlerUser() && 
            <ListOwnerships showFilters={showFilters} startLoading={startLoading} stopLoading={stopLoading} searchFilter={{isActive: true}} />
          }
        </Paper>
    </Page>
  )
}